import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { func, object } from 'prop-types'
import { Input } from '../ui/inputs/Input'
import { validationAvanceImmediate } from './validators'
import { stores, view } from '../../stores'
import { validateReferences } from '../../utilities/validators'
import { withRouter } from 'react-router'
import { Select } from '../ui/inputs/Select'
import { SelectStringGroup } from '../ui/inputs/SelectStringGroup'
import { Birthdate } from '../ui/inputs/Birthdate'
import { PhoneInput } from '../ui/inputs/PhoneInput'
import { CountryInput } from '../ui/inputs/CountryInput'
import { CodeTypeVoieResidence } from '../../constants/CodeTypeVoieResidence'
import moment from 'moment'

class AvanceImmediateFormComponent extends Component {
  constructor (props) {
    super(props)
    const { lastAttemptInformation } = this.props
    const lastAttemptRequestBody = JSON.parse((lastAttemptInformation && lastAttemptInformation.requestBody) || '{}')
    this.state = {
      error: '',
      lastAttemptErrors: lastAttemptInformation && lastAttemptInformation.errors,
      form: {
        civilite: (lastAttemptRequestBody && lastAttemptRequestBody.civilite) || 'MONSIEUR',
        nomNaissance: (lastAttemptRequestBody && lastAttemptRequestBody.nomNaissance) || '',
        nomUsage: (lastAttemptRequestBody && lastAttemptRequestBody.nomUsage) || '',
        prenoms: (lastAttemptRequestBody && lastAttemptRequestBody.prenoms) || '',
        dateNaissance: (lastAttemptRequestBody && lastAttemptRequestBody.dateNaissance && moment(lastAttemptRequestBody.dateNaissance).format('DD/MM/YYYY')) || null,
        numeroTelephonePortable: (lastAttemptRequestBody && lastAttemptRequestBody.numeroTelephonePortable) || null,
        adresseMail: (lastAttemptRequestBody && lastAttemptRequestBody.adresseMail) || '',
        codePaysIso2Naissance: (lastAttemptRequestBody && lastAttemptRequestBody.lieuNaissance && lastAttemptRequestBody.lieuNaissance.codePays && lastAttemptRequestBody.lieuNaissance.codePays.toLowerCase()) || 'fr',
        villeNaissanceLibelle: (lastAttemptRequestBody && lastAttemptRequestBody.lieuNaissance && lastAttemptRequestBody.lieuNaissance.libelleCommune) || '',
        villeNaissanceCodePostal: (lastAttemptRequestBody && lastAttemptRequestBody.lieuNaissance && lastAttemptRequestBody.lieuNaissance.codePostal) || '',
        codePaysIso2Residence: (lastAttemptRequestBody && lastAttemptRequestBody.adressePostale && lastAttemptRequestBody.adressePostale.codePays && lastAttemptRequestBody.adressePostale.codePays.toLowerCase()) || 'fr',
        villeResidenceLibelle: (lastAttemptRequestBody && lastAttemptRequestBody.adressePostale && lastAttemptRequestBody.adressePostale.libelleCommune) || '',
        villeResidenceCodePostal: (lastAttemptRequestBody && lastAttemptRequestBody.adressePostale && lastAttemptRequestBody.adressePostale.codePostal) || '',
        lieuDitResidence: (lastAttemptRequestBody && lastAttemptRequestBody.adressePostale && lastAttemptRequestBody.adressePostale.lieuDit) || '',
        numeroVoieResidence: (lastAttemptRequestBody && lastAttemptRequestBody.adressePostale && lastAttemptRequestBody.adressePostale.numeroVoie) || '',
        libelleVoieResidence: (lastAttemptRequestBody && lastAttemptRequestBody.adressePostale && lastAttemptRequestBody.adressePostale.libelleVoie) || '',
        complementResidence: (lastAttemptRequestBody && lastAttemptRequestBody.adressePostale && lastAttemptRequestBody.adressePostale.complement) || '',
        codeTypeVoieResidence: (lastAttemptRequestBody && lastAttemptRequestBody.adressePostale && lastAttemptRequestBody.adressePostale.codeTypeVoie) || 'R',
        lettreVoieResidence: (lastAttemptRequestBody && lastAttemptRequestBody.adressePostale && lastAttemptRequestBody.adressePostale.lettreVoie) || '',
        bic: (lastAttemptRequestBody && lastAttemptRequestBody.coordonneeBancaire && lastAttemptRequestBody.coordonneeBancaire.bic) || '',
        iban: (lastAttemptRequestBody && lastAttemptRequestBody.coordonneeBancaire && lastAttemptRequestBody.coordonneeBancaire.iban) || '',
        titulaire: (lastAttemptRequestBody && lastAttemptRequestBody.coordonneeBancaire && lastAttemptRequestBody.coordonneeBancaire.titulaire) || ''
      }
    }
  }

  validate () {
    const { isValid } = validateReferences(this.refs)
    const { t } = this.props
    if (!isValid) {
      this.setState({ error: t('common:fields:incomplete_form') })
    } else {
      this.setState({ error: '' })
    }
    return isValid
  }

  update (key) {
    return (value) => {
      this.setState({
        form: {
          ...this.state.form,
          [key]: value
        }
      })
    }
  }

  /**
   * Some fields should require password confirmation
   * @returns boolean
   */
  shouldAskConfirmation () {
    return (
      stores.account.connected.email !== stores.account.update.email ||
      this.state.newPassword !== ''
    )
  }

  async submit () {
    const { t } = this.props
    stores.avanceImmediate.sendInfos({
      civilite: this.state.form.civilite,
      nomNaissance: this.state.form.nomNaissance,
      nomUsage: this.state.form.nomUsage,
      prenoms: this.state.form.prenoms,
      dateNaissance: this.state.form.dateNaissance && moment(this.state.form.dateNaissance, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      numeroTelephonePortable: (this.state.form.numeroTelephonePortable.dialCode === '33' && this.state.form.numeroTelephonePortable.phone.startsWith('0')
        ? this.state.form.numeroTelephonePortable.phone : this.state.form.numeroTelephonePortable.value).replace(/\s/g, ''),
      adresseMail: this.state.form.adresseMail,
      lieuNaissance: {
        codeIsoPays: this.state.form.codePaysIso2Naissance,
        libelleCommune: this.state.form.villeNaissanceLibelle,
        codePostal: this.state.form.villeNaissanceCodePostal
      },
      adressePostale: {
        codeIsoPays: this.state.form.codePaysIso2Residence,
        libelleCommune: this.state.form.villeResidenceLibelle,
        codePostal: this.state.form.villeResidenceCodePostal,
        numeroVoie: this.state.form.numeroVoieResidence,
        libelleVoie: this.state.form.libelleVoieResidence,
        lieuDit: this.state.form.lieuDitResidence,
        complement: this.state.form.complementResidence,
        codeTypeVoie: this.state.form.codeTypeVoieResidence || null,
        lettreVoie: this.state.form.lettreVoieResidence || null
      },
      coordonneeBancaire: {
        bic: this.state.form.bic,
        iban: this.state.form.iban,
        titulaire: this.state.form.titulaire
      }
    }).catch(() => {
      window.alert(t('common:avance_immediate:form:api_error'))
      window.location.reload()
    })
  }

  render () {
    const { t } = this.props

    return (
      <div>
        <div className='account__edit__notif'>
          {
            this.state.lastAttemptErrors &&
            <div style={{ marginBottom: '30px' }}>
              <h2 style={{ fontWeight: '500' }}>{t('common:avance_immediate:title_last_attempt_info')}</h2>
              {
                this.state.lastAttemptErrors.split(/\n/).map(line =>
                  <div key={line}>
                    <label className={'form__label--error'}>{line}</label>
                  </div>
                )
              }
            </div>
          }

          <h2 style={{ fontWeight: '500' }}>{t('common:avance_immediate:title_general_info')}</h2>
          <SelectStringGroup label={t('common:avance_immediate:form:civilite')} selectedValue={this.state.form.civilite}
            onChange={this.update('civilite')} name='civilite'>
            <Select value='MONSIEUR'>Monsieur</Select>
            <Select value='MADAME'>Madame</Select>
          </SelectStringGroup>
          <Input value={this.state.form.prenoms} instructions={t('common:avance_immediate:form:instructions:prenoms')}
            onChange={this.update('prenoms')} ref='prenoms'
            label={t('common:avance_immediate:form:prenoms')} name='prenoms' type='text'
            rules={validationAvanceImmediate.prenoms}
            placeholder={t('common:avance_immediate:form:placeholders:prenoms')} />
          <Input value={this.state.form.nomNaissance} onChange={this.update('nomNaissance')} ref='nomNaissance'
            label={t('common:avance_immediate:form:nomNaissance')} name='nomNaissance' type='text'
            rules={validationAvanceImmediate.nomNaissance}
            placeholder={t('common:avance_immediate:form:placeholders:nomNaissance')} />
          <Input value={this.state.form.nomUsage} onChange={this.update('nomUsage')} ref='nomUsage'
            label={t('common:avance_immediate:form:nomUsage')} name='nomUsage' type='text'
            instructions={t('common:avance_immediate:form:instructions:nomUsage')}
            placeholder={t('common:avance_immediate:form:placeholders:nomUsage')} />
          <Birthdate value={this.state.form.dateNaissance} onChange={this.update('dateNaissance')} ref='dateNaissance'
            label={t('common:avance_immediate:form:dateNaissance')} name='dateNaissance' type='text' />
          <CountryInput value={this.state.form.codePaysIso2Naissance} onChange={this.update('codePaysIso2Naissance')}
            ref='codePaysIso2Naissance'
            label={t('common:avance_immediate:form:codePaysIso2Naissance')} name='codePaysIso2Naissance'
            type='text' />
          {
            this.state.form.codePaysIso2Naissance === 'fr' &&
            <div>
              <Input value={this.state.form.villeNaissanceCodePostal}
                label={t('common:avance_immediate:form:villeNaissanceCodePostal')}
                onChange={this.update('villeNaissanceCodePostal')} ref='villeNaissanceCodePostal'
                name='villeNaissanceCodePostal' type='text'
                rules={validationAvanceImmediate.villeNaissanceCodePostal}
                placeholder={t('common:avance_immediate:form:placeholders:villeNaissanceCodePostal')} />
              <Input value={this.state.form.villeNaissanceLibelle}
                label={t('common:avance_immediate:form:villeNaissanceLibelle')}
                onChange={this.update('villeNaissanceLibelle')} ref='villeNaissanceLibelle'
                name='villeNaissanceLibelle' type='text'
                placeholder={t('common:avance_immediate:form:placeholders:villeNaissanceLibelle')} />
            </div>
          }
        </div>

        <div className='account__edit__notif'>
          <h2 style={{ fontWeight: '500' }}>{t('common:avance_immediate:title_contact_info')}</h2>
          <PhoneInput value={this.state.form.numeroTelephonePortable} onChange={this.update('numeroTelephonePortable')}
            ref='numeroTelephonePortable' label={t('common:avance_immediate:form:numeroTelephonePortable')}
            name='numeroTelephonePortable' type='text'
            rules={validationAvanceImmediate.numeroTelephonePortable}
            placeholder={t('common:avance_immediate:form:placeholders:numeroTelephonePortable')} required />
          <Input value={this.state.form.adresseMail} onChange={this.update('adresseMail')} ref='adresseMail'
            label={t('common:avance_immediate:form:adresseMail')} name='adresseMail' type='text'
            rules={validationAvanceImmediate.adresseMail}
            placeholder={t('common:avance_immediate:form:placeholders:adresseMail')} />
          <CountryInput value={this.state.form.codePaysIso2Residence} onChange={this.update('codePaysIso2Residence')}
            ref='codePaysIso2Residence'
            label={t('common:avance_immediate:form:codePaysIso2Residence')} name='codePaysIso2Residence'
            type='text'
            placeholder={t('common:avance_immediate:form:placeholders:codePaysIso2Residence')} />

          {
            this.state.form.codePaysIso2Residence === 'fr' &&
            <div>
              <Input value={this.state.form.villeResidenceLibelle}
                label={t('common:avance_immediate:form:villeResidenceLibelle')}
                onChange={this.update('villeResidenceLibelle')} ref='villeResidenceLibelle'
                name='villeResidenceLibelle' type='text'
                placeholder={t('common:avance_immediate:form:placeholders:villeResidenceLibelle')} />
              <Input value={this.state.form.villeResidenceCodePostal}
                label={t('common:avance_immediate:form:villeResidenceCodePostal')}
                onChange={this.update('villeResidenceCodePostal')} ref='villeResidenceCodePostal'
                name='villeResidenceCodePostal' type='text'
                rules={validationAvanceImmediate.villeResidenceCodePostal}
                placeholder={t('common:avance_immediate:form:placeholders:villeResidenceCodePostal')} />
              <Input value={this.state.form.numeroVoieResidence}
                label={t('common:avance_immediate:form:numeroVoieResidence')}
                onChange={this.update('numeroVoieResidence')} ref='numeroVoieResidence'
                name='numeroVoieResidence' type='text'
                placeholder={t('common:avance_immediate:form:placeholders:numeroVoieResidence')} />
              <SelectStringGroup label={t('common:avance_immediate:form:codeTypeVoieResidence')}
                selectedValue={this.state.form.codeTypeVoieResidence}
                onChange={this.update('codeTypeVoieResidence')} name='codeTypeVoieResidence'>
                {
                  CodeTypeVoieResidence.map((item) => <Select key={item.code} value={item.code}>{item.label}</Select>)
                }
              </SelectStringGroup>
              <Input value={this.state.form.libelleVoieResidence}
                label={t('common:avance_immediate:form:libelleVoieResidence')}
                onChange={this.update('libelleVoieResidence')} ref='libelleVoieResidence'
                name='libelleVoieResidence' type='text'
                placeholder={t('common:avance_immediate:form:placeholders:libelleVoieResidence')} />
              <SelectStringGroup label={t('common:avance_immediate:form:lettreVoieResidence')}
                selectedValue={this.state.form.lettreVoieResidence}
                onChange={this.update('lettreVoieResidence')} name='lettreVoieResidence'>
                <Select value='' />
                <Select value='BIS'>BIS</Select>
                <Select value='TER'>TER</Select>
                <Select value='QUATER'>QUATER</Select>
                <Select value='QUINQUIES'>QUINQUIES</Select>
              </SelectStringGroup>
              <Input value={this.state.form.complementResidence}
                label={t('common:avance_immediate:form:complementResidence')}
                onChange={this.update('complementResidence')} ref='complementResidence'
                name='complementResidence' type='text'
                placeholder={t('common:avance_immediate:form:placeholders:complementResidence')} />
              <Input value={this.state.form.lieuDitResidence} label={t('common:avance_immediate:form:lieuDitResidence')}
                onChange={this.update('lieuDitResidence')} ref='lieuDitResidence'
                name='lieuDitResidence' type='text'
                placeholder={t('common:avance_immediate:form:placeholders:lieuDitResidence')} />
            </div>
          }
        </div>
        <div className='account__edit__notif'>
          <h2 style={{ fontWeight: '500' }}>{t('common:avance_immediate:title_payment_info')}</h2>
          <Input value={this.state.form.bic} onChange={this.update('bic')} ref='bic'
            label={t('common:avance_immediate:form:bic')} name='bic' type='text'
            rules={validationAvanceImmediate.bic}
            placeholder={t('common:avance_immediate:form:placeholders:bic')}
            instructions={t('common:avance_immediate:form:instructions:bic')}
          />

          <Input value={this.state.form.iban} onChange={this.update('iban')} ref='iban'
            label={t('common:avance_immediate:form:iban')} name='iban' type='text'
            rules={validationAvanceImmediate.iban}
            placeholder={t('common:avance_immediate:form:placeholders:iban')}
            instructions={t('common:avance_immediate:form:instructions:iban')} />
          <Input value={this.state.form.titulaire} onChange={this.update('titulaire')} ref='titulaire'
            label={t('common:avance_immediate:form:titulaire')} name='titulaire' type='text'
            rules={validationAvanceImmediate.titulaire}
            placeholder={t('common:avance_immediate:form:placeholders:titulaire')}
            instructions={t('common:avance_immediate:form:instructions:titulaire')}
          />
        </div>
        <button
          style={{ marginTop: '30px' }}
          onClick={() => this.validate() && this.submit()}
          className='btn--green layout--centered'>{t('common:avance_immediate:send_infos')}</button>
        {this.state && this.state.error !== '' &&
          <p className='form__errormessage' style={{ textAlign: 'center' }}>{this.state.error}</p>}
      </div>
    )
  }
}

AvanceImmediateFormComponent.propTypes = {
  t: func,
  history: object
}

export const AvanceImmediateForm = withRouter(translate()(view(AvanceImmediateFormComponent)))



// WEBPACK FOOTER //
// ./src/components/customer/AvanceImmediateForm.js